import { getEnvironment } from '@backoffice-frontend/environment'
import {
  Body2,
  ContentInfo,
  H5,
  MoiaButton,
  MoiaGrid,
  MoiaViewBox,
  Subtitle1,
} from '@backoffice-frontend/patterns'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

const contentBlock = {
  whiteSpace: 'pre-wrap',
  textAlign: 'start',
  px: 1,
  py: 2,
} as const

const getBackofficeFrontendEmail = (): string =>
  `backoffice-dev+${getEnvironment()}-frontend-error@moia.io`

export const ErrorBoundaryView = ({
  error: unkownError,
  areaId,
}: {
  error: unknown
  areaId: string
}) => {
  const { t } = useTranslation()
  const location = useLocation()

  const error = unkownError as Error

  const getSerializedContext = () =>
    JSON.stringify({ areaId, location, history }, undefined, 4)

  const createEmailLink = () => {
    const contextBody = `Context:\n${getSerializedContext()}\n`

    const emailBody = encodeURI(
      `Message:\n${error?.message}\n\n` +
        `StackTrace:\n${error?.stack}\n\n` +
        `${contextBody}`,
    )

    const emailLink = `mailto:${getBackofficeFrontendEmail()}?&subject=An error occurred, please contact us with a detailed description of how the error occurred. This is what will be sent:&body=${emailBody}`

    return emailLink
  }

  const context = getSerializedContext()

  return (
    <MoiaViewBox>
      <MoiaGrid>
        <ContentInfo
          title={t('globalErrorView_criticalError_headline')}
          variant="criticalAlert"
        />
        <H5>{t('globalErrorView_errorDetails_headline')}</H5>
        <Subtitle1>{t('globalErrorView_errorMessage_headline')}</Subtitle1>
        <Body2 css={contentBlock}>{error?.message}</Body2>
        <Subtitle1>{t('globalErrorView_stackTrace_headline')}</Subtitle1>
        <Body2 css={contentBlock}>{error?.stack?.trim()}</Body2>
        {context && (
          <>
            <Subtitle1>{t('globalErrorView_errorContext_headline')}</Subtitle1>
            <Body2 css={contentBlock}>{context}</Body2>
          </>
        )}

        <MoiaButton color="primary" href={createEmailLink()} target="_blank">
          {t('globalErrorView_sendErrorReport_button')}
        </MoiaButton>
      </MoiaGrid>
    </MoiaViewBox>
  )
}
